export default {"src":"/newStatic/_next/static/media/footer-pattern.20a6e347.svg","height":107,"width":227};